import React from 'react';
import PropTypes from 'prop-types';

export default function Image({ alt, src, ...props }) {
  return <img {...props} alt={alt} src={src} />;
}

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
};
